import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addHob from 'rangeConfig/knoxhult/behaviors/addHob';
import addHood from 'rangeConfig/knoxhult/behaviors/addHood';
import addOven from 'rangeConfig/knoxhult/behaviors/addOven';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';

export const hobsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.integratedHobsMenuTitle',
  cluster: [],
  behaviors: {
    productClicked: [addHob],
    productDropped: [addHob]
  },
  sortOrder: [{ path: 'name' }],
  categories: [
    {
      id: 'integrated-hobs',
      products: [{ path: 'type', value: ProductType.APPLIANCE_INTEGRATED_HOB }]
    }
  ]
};

export const ovensProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.integratedOvensMenuTitle',
  cluster: [],
  behaviors: {
    productClicked: [addOven],
    productDropped: [addOven]
  },
  sortOrder: [{ path: 'name' }],
  categories: [
    {
      id: 'integrated-ovens',
      products: [{ path: 'type', value: ProductType.APPLIANCE_INTEGRATED_OVEN }]
    }
  ]
};

export const hoodsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.integratedOvensMenuTitle',
  cluster: [],
  behaviors: {
    productClicked: [addHood],
    productDropped: [addProduct]
  },
  sortOrder: [{ path: 'name' }],
  categories: [
    {
      id: 'extractor-hoods',
      products: [
        { path: 'type', value: ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD },
        { path: 'type', value: ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD }
      ]
    }
  ]
};

export const fridgeProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.integratedOvensMenuTitle',
  cluster: [],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  sortOrder: [{ path: 'name' }],
  categories: [
    {
      id: 'integrated-ovens',
      products: [{ path: 'type', value: ProductType.APPLIANCE_FRIDGE_FREEZER }]
    }
  ]
};

export const appliancesProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.appliances',
  cluster: [],
  behaviors: {
    productClicked: [],
    productDropped: []
  },
  sortOrder: [],
  categories: []
};
